var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-navigation-drawer",class:{'ed-navigation-drawer__open': _vm.isOpen, 'ed-navigation-drawer__absolute': _vm.absolute}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }